import React from "react";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/PublicLayout";
import { Breadcrumbs } from "@/components/Marketing";
import WhatsAppButton from "@/components/WhatsAppButton";
import CallButton from "@/components/CallButton";
import { useSite } from "@/context/SiteContext";
import { waMessages } from "@/lib/whatsapp";
import { MapPin, Mail, Phone, Clock, MessageCircle } from "lucide-react";

export default function Contact() {
  const { settings } = useSite();
  const s = settings || {};
  const rows = [
    s.phone && { icon: Phone, label: "Phone", value: s.phone },
    s.email && { icon: Mail, label: "Email", value: s.email },
    { icon: MapPin, label: "Service Area", value: s.service_area || "Greater Manchester" },
    s.address && { icon: MapPin, label: "Address", value: s.address },
    { icon: Clock, label: "Opening Hours", value: s.opening_hours || "Mon–Sat 9am–7pm" },
  ].filter(Boolean);

  return (
    <PublicLayout>
      <Seo title="Contact — Manchester PHV Rental" description="Get in touch with EazyCarTrack about Manchester licensed PHV rental. WhatsApp is the fastest way to reach us about current availability." path="/contact" />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Contact" }]} />
      <div className="container-x grid gap-12 py-8 lg:grid-cols-2">
        <div>
          <h1 className="font-heading text-4xl font-black uppercase tracking-tighter sm:text-5xl">Contact Us</h1>
          <p className="mt-4 max-w-lg leading-relaxed text-zinc-600">
            The fastest way to reach us is WhatsApp, but you're welcome to call us too. Tell us which
            vehicle you're interested in and we'll confirm current availability, pricing and the
            requirements to rent.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <WhatsAppButton size="lg" message={waMessages.general()} context="contact" testid="contact-whatsapp">
              WhatsApp Us Now
            </WhatsAppButton>
            <CallButton size="lg" variant="dark" context="contact" testid="contact-call" showNumber>
              Call Us
            </CallButton>
          </div>
        </div>
        <div className="border border-border">
          <ul className="divide-y divide-border">
            {rows.map((r, i) => (
              <li key={i} className="flex items-start gap-4 p-6">
                <r.icon className="mt-0.5 h-5 w-5 shrink-0 text-[#00E676]" />
                <div>
                  <div className="text-[11px] font-bold uppercase tracking-wider text-zinc-500">{r.label}</div>
                  <div className="mt-0.5 font-semibold text-zinc-900">{r.value}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </PublicLayout>
  );
}
